(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["settings-panel/recent-components"] = factory();
	else
		root["settings-panel/recent-components"] = factory();
})(globalThis, () => {
return 